import _extends from "@babel/runtime/helpers/esm/extends";
import { useInitialState } from "../_";
import { SuperDashboardCard } from "../SuperDashboard";
import { Flex, Tag, Typography } from 'antd';
import BoringAvatar from 'boring-avatars';
import React from 'react';
export var Account = /*#__PURE__*/React.forwardRef(function (properties, ref) {
  var _initialState$user, _initialState$user2, _initialState$user3;
  var _useInitialState = useInitialState(),
    initialState = _useInitialState.initialState;
  return /*#__PURE__*/React.createElement(SuperDashboardCard, _extends({
    ref: ref
  }, properties), /*#__PURE__*/React.createElement(Flex, {
    justify: "space-around",
    align: "center",
    gap: "large",
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    flex: 4,
    align: "center"
  }, /*#__PURE__*/React.createElement(BoringAvatar, {
    size: "100%",
    variant: "beam",
    name: (initialState === null || initialState === void 0 || (_initialState$user = initialState.user) === null || _initialState$user === void 0 ? void 0 : _initialState$user.name) || 'root',
    colors: ['#C4DDD6', '#D4DDD6', '#E4DDD6', '#E4E3CD', '#ECECDD']
  })), /*#__PURE__*/React.createElement(Flex, {
    flex: 20,
    vertical: true,
    justify: "center",
    gap: "small"
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(Flex, {
    gap: "small"
  }, /*#__PURE__*/React.createElement(Typography.Text, {
    copyable: true
  }, initialState === null || initialState === void 0 || (_initialState$user2 = initialState.user) === null || _initialState$user2 === void 0 ? void 0 : _initialState$user2.name), /*#__PURE__*/React.createElement(Tag, {
    color: "cyan"
  }, "\u4E3B\u8D26\u53F7"))), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(Typography.Text, null, "\u7F16\u53F7: "), /*#__PURE__*/React.createElement(Typography.Text, {
    ellipsis: true,
    copyable: true,
    style: {
      width: 'calc(100% - 1.5 * 32px)'
    }
  }, initialState === null || initialState === void 0 || (_initialState$user3 = initialState.user) === null || _initialState$user3 === void 0 ? void 0 : _initialState$user3.uuid)))), properties.children);
});
Account.isProCard = true;